import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowCircleUpFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.24994C6.61482 2.24994 2.24994 6.61483 2.24994 12C2.24994 17.3852 6.61482 21.7501 12 21.7501C17.3852 21.7501 21.7501 17.3852 21.7501 12C21.7501 6.61483 17.3852 2.24995 12 2.24994ZM8.28768 10.409C7.99479 10.7019 7.99479 11.1768 8.28768 11.4697C8.58058 11.7626 9.05545 11.7626 9.34834 11.4697L11.25 9.56801L11.25 16.2426C11.25 16.6568 11.5858 16.9926 12 16.9926C12.4142 16.9926 12.75 16.6568 12.75 16.2426L12.75 9.56801L14.6516 11.4697C14.9445 11.7626 15.4194 11.7626 15.7123 11.4697C16.0052 11.1768 16.0052 10.7019 15.7123 10.409L12.5303 7.22702C12.2374 6.93413 11.7626 6.93413 11.4697 7.22702L8.28768 10.409Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgArrowCircleUpFilled);
export default ForwardRef;
